import React, { useState } from 'react'
import img from '../../assets/sample.png'
// import save from '../../assets/save.png'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { IoBookmarkOutline } from "react-icons/io5";
import { IoBookmark } from "react-icons/io5";
import { useSearch } from '../../hooks/SearchContext';

const JobCard = ({ job }) => {

    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    // ${location.pathname != '/jobs' && 'min-w-[340px]'}

    const formatPostedDate = (createdAt) => {
        return new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
        }).format(new Date(createdAt));
    };


    const { savedJobs, setSavedJobs } = useSearch();

    const toggleSaveJob = (jobId) => {
        setSavedJobs((prev) =>
            prev.includes(jobId) ? prev.filter((id) => id !== jobId) : [...prev, jobId]
        );
    };



    return (
        <div className={`${location.pathname == '/' && 'ml-6'} hover:bg-[#E6F7FF] ${id == job?._id ? "bg-[#E6F7FF]" : "bg-white"} p-6 rounded-[20px] flex flex-col gap-6 shadow !w-full 
        min-w-[340px] 
        max-w-[360px] cursor-pointer transition-all duration-100 ease-in-out`}
            onClick={() => navigate(`/job/${job?._id}`)}
        >

            <div className='flex gap-4'>

                {job?.iconURL ?
                    <div className='h-12 p-2 bg-[#f1f1f1] rounded-full'>
                        <img src={job?.iconURL} alt='logo' className='h-full object-contain' />
                    </div>
                    :
                    <div className='h-12'>
                        <img src={img} alt='logo' className='h-full object-contain' />
                    </div>
                }

                <div className='flex flex-col flex-grow gap-2 justify-between'>
                    <div className='text-sm font-medium'>
                        {job?.title}
                    </div>

                    <div className='text-[11px] flex gap-3 font-light text-[rgba(0, 0, 0, 0.59)]'>
                        <div>{job?.department}</div>
                        <div>{job?.applicants} applicants</div>
                    </div>
                </div>


                <div className='h-6'>
                    <IoBookmarkOutline
                        className={`text-2xl cursor-pointer transition-all ${savedJobs.includes(job?._id) ? "hidden" : "block"}`}
                        onClick={() => toggleSaveJob(job?._id)}
                        onMouseEnter={(e) => e.currentTarget.style.color = "#EE7828B5"} // Change color on hover
                        onMouseLeave={(e) => e.currentTarget.style.color = ""}
                    />

                    <IoBookmark
                        className={`text-2xl cursor-pointer transition-all ${savedJobs.includes(job?._id) ? "block" : "hidden"}`}
                        onClick={() => toggleSaveJob(job?._id)}
                        onMouseEnter={(e) => e.currentTarget.style.color = "#EE7828B5"} // Change color on hover
                        onMouseLeave={(e) => e.currentTarget.style.color = ""}
                    />

                </div>

            </div>


            <div className='flex gap-6 items-center'>

                <div className='JobLabel blue'>{job?.category}</div>
                <div className='JobLabel purple'>{job?.experienceLevel}</div>
                <div className='JobLabel peach'>{job?.locationType}</div>

            </div>

            {location.pathname == '/' ?
                <div className='font-light text-[rgba(0, 0, 0, 0.59)] text-[11px] pb-4 border-b'
                    style={{ borderColor: "rgba(0, 0, 0, 0.59)" }}
                >
                    {job?.description}
                </div>
                :
                <></>
            }

            <div className='flex justify-between items-center mt-[-8px]'>
                <div className='font-semibold'>
                    ₹ {job?.salaryRange}
                </div>

                <div className='text-[11px] font-light text-[rgba(0, 0, 0, 0.59)]'>
                    Posted {formatPostedDate(job.createdAt)}
                </div>

            </div>


        </div>
    )
}

export default JobCard